import { DateTime } from "luxon";
import * as React from "react";
import { Text, TextInput } from "@mantine/core";

type TimeSelectorProps = {
  time: DateTime;
  name: string;

  tz?: string;

  minTime?: DateTime | null;
  maxTime?: DateTime | null;

  onChange: (name: string, value: string) => void;
};

const setTimeOf = (date: DateTime, time: string, tz?: string) => {
  const oldTime = DateTime.fromFormat(time, "HH:mm");
  return date.setZone(tz || date.zone).set({
    hour: oldTime.get("hour"),
    minute: oldTime.get("minute"),
    second: 0,
  })
};

const TimeSelector: React.FunctionComponent<TimeSelectorProps> = ({
  time,
  name,
  onChange,
  minTime,
  maxTime,
  tz,
}) => (
  <TextInput
    type="time"
    name={name}
    onChange={(e) => {
      const newTime = setTimeOf(time, e.currentTarget.value, tz);
      if (minTime && newTime < minTime) return onChange(name, minTime.toISO()!);
      if (maxTime && newTime > maxTime) return onChange(name, maxTime.toISO()!);
      onChange(name, newTime.toISO()!);
    }}
    style={{ display: "inline" }}
    value={(tz ? time.setZone(tz) : time).toFormat("HH:mm")}
  />
);

export default TimeSelector;
